export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-grid',
    },
    {
      name: 'Create',
      url: '/create',
      icon: 'icon-note',
    },
    {
      name: 'Build',
      url: '/build',
      icon: 'icon-speedometer',
    },
    {
      name: 'Manage',
      url: '/manage',
      icon: 'icon-wrench',
      children: [
        {
          name: 'My scenes',
          url: '/manage/manage-scene',
          icon: 'icon-cursor',
        },
        {
          name: 'My subscription',
          url: '/manage/sub-scription',
          icon: 'icon-cursor',
        }
      ],
    },
    {
      name: 'Grow',
      url: '/grow',
      icon: 'icon-graph',
      children: [
        {
          name: 'Promote',
          url: '/grow/social',
          icon: 'icon-cursor',
        },
        {
          name: 'Push notification',
          url: '/grow/push-manager',
          icon: 'icon-cursor',
        },
      ],
    },
    {
      name: 'Settings',
      url: '/setting',
      icon: 'icon-settings',
    },
    {
      name: 'Add ons',
      url: '/addons',
      icon: 'icon-puzzle',
    },
    {
      name: 'Analytics',
      url: '/analytics',
      icon: 'icon-bell',
    },
  ]
};



// WEBPACK FOOTER //
// ./src/_nav.js